import { Keyboard, useHotkeyListener } from "@hex-insights/core";

const arrowLeftHotkey: Keyboard.Hotkey = {
	key: Keyboard.keyArrowLeft,
	altKey: false,
	ctrlKey: false,
	metaKey: false,
};

const arrowRightHotkey: Keyboard.Hotkey = {
	key: Keyboard.keyArrowRight,
	altKey: false,
	ctrlKey: false,
	metaKey: false,
};

export function useHorizontalArrowKeyNavigation(back: () => void, forward: () => void) {
	useHotkeyListener(arrowLeftHotkey, back);
	useHotkeyListener(arrowRightHotkey, forward);
}
